/* eslint-disable no-nested-ternary */
/* eslint-disable no-return-assign */
/* eslint-disable prefer-template */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable arrow-body-style */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-danger */
/* eslint-disable react/button-has-type */
import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Search, FileText, Zap, Trash2, ClipboardList, MoreVertical, Eye, RefreshCw, Upload, GripVertical } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import Page from '../../../components/Page';
import ResponsiveTable from '../../../components/Table/Responsivetable';
import DeleteAlert from '../../../components/modal/DeleteModal';
import SnackBar from '../../../components/snackbar/snackbar';
import adminServices from '../../../services/adminServices';
import useDebounce from '../../../hooks/useDebounce';
import ViewAssessmentModal from './ViewAssessmentModal';
import AssessmentOrderModal from './assessmentorder';

const Assessments = () => {
  const navigate = useNavigate();
  const menuRefs = useRef({});
  const [assessments, setAssessments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('');
  const [typeFilter, setTypeFilter] = useState('');
  const [length, setLength] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [maxCount, setMaxCount] = useState(0);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarTitle, setSnackbarTitle] = useState('');
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedAssessment, setSelectedAssessment] = useState(null);
  const [openActionMenuId, setOpenActionMenuId] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewAssessment, setPreviewAssessment] = useState(null);
  const [modalType, setModalType] = useState(null);
  const [selectedAssessmentForAction, setSelectedAssessmentForAction] = useState(null);
  const [publishMessage, setPublishMessage] = useState('');
  const [publishFromDate, setPublishFromDate] = useState('');
  const [publishToDate, setPublishToDate] = useState('');
  const [actionType, setActionType] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const debouncedSearch = useDebounce(search, 500);
  // const [menuOpenUp, setMenuOpenUp] = useState(false);
  const [assessmentTypeList, setAssessmentTypeList] = useState([]);
  const [orderModalOpen, setOrderModalOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, right: 0 });
  console.log(assessments, "assessments");


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openActionMenuId &&
        menuRefs.current[openActionMenuId] &&
        !menuRefs.current[openActionMenuId].contains(event.target)
      ) {
        setOpenActionMenuId(null);
      }
    };
    const handleScroll = () => setOpenActionMenuId(null);

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("scroll", handleScroll, true);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("scroll", handleScroll, true);
    };
  }, [openActionMenuId]);
  const getDifficultyColor = (status) => {
    switch (status) {
      case 'ACTIVE':
        return 'bg-green-100 text-green-800';
      case 'INACTIVE':
        return 'bg-yellow-100 text-yellow-800';
      // case '"ON_MAINTENANCE"':
      //   return 'bg-red-100 text-red-800';

      default:
        return 'bg-red-100 text-red-800';
    }
  };

  useEffect(() => {
    getAssessmentTypeList();
  }, [])

  const getAssessmentTypeList = async () => {
    try {
      const result = await adminServices.getAssessmentTypeDropdown();
      if (result && result.ok) {
        const list = result.data?.data || result.data || [];
        setAssessmentTypeList(list.filter(item => item.is_active));
      }
    } catch (error) {
      console.error('Assessment Type dropdown API not ready:', error);
      setAssessmentTypeList([]);
    }
  };



  const getAssessments = async () => {
    setLoading(true);
    try {
      const result = await adminServices.getAssessments(debouncedSearch, typeFilter, statusFilter, page, size, category, length);
      if (result?.data?.data) {
        setAssessments(result.data.data);
        setMaxCount(typeof result.data.totalCount === 'number' ? result.data.totalCount : result.data.data.length);
      } else {
        setAssessments([]);
        setMaxCount(0);
      }
    } catch (error) {
      console.error('Error fetching assessments:', error);
      setAssessments([]);
      setMaxCount(0);
      setSnackbarTitle('Error fetching assessments');
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setPage(1);
    const timer = setTimeout(() => {
      getAssessments();
    }, 0);

    return () => clearTimeout(timer);
  }, [debouncedSearch, typeFilter, statusFilter, size, category, length]);

  useEffect(() => {
    if (page) {
      getAssessments();
    }
  }, [page]);

  const handleCreateLinear = () => {
    navigate('/app/assessmentCreate?type=linear');
  };

  const handleCreateAdaptive = () => {
    navigate('/app/assessmentCreate?type=adaptive');
  };

  const handleClearFilters = () => {
    setSearch('');
    setCategory('')
    setTypeFilter('');
    setStatusFilter('');
    setLength('')
  };

  const NavigateEdit = (assessment) => {
    if (assessment.assessment_pattern_name === 'Linear') {
      navigate('/app/assessmentCreate?type=linear', { state: { assessmentId: assessment.id } });
    } else {
      navigate('/app/assessmentCreate?type=adaptive', { state: { assessmentId: assessment.id } });
    }
  }

  const handleActionClick = (action, assessment) => {
    switch (action) {
      case 'edit':
        if (assessment.assessment_pattern_name === 'Linear') {
          navigate('/app/assessmentCreate?type=linear', { state: { assessmentId: assessment.id } });
        } else {
          navigate('/app/assessmentCreate?type=adaptive', { state: { assessmentId: assessment.id } });
        }
        break;
      case 'delete':
        setSelectedAssessment(assessment);
        setDeleteModalOpen(true);
        break;
      case 'continueEditing':
        if (assessment.status !== "ACTIVE") {
          if (assessment.assessment_pattern_name === 'Linear') {
            navigate('/app/assessmentCreate?type=linear', { state: { assessmentId: assessment.id } });
          } else {
            navigate('/app/assessmentCreate?type=adaptive', { state: { assessmentId: assessment.id } });
          }
        } else {
          setSelectedAssessmentForAction(assessment);
          setActionType('edit');
          setModalType('confirm');
        }
        break;


      case 'publishChanges':
        setSelectedAssessmentForAction(assessment);
        setActionType('publish');
        setModalType('confirm');
        break;
      case 'unpublishChanges':
        setSelectedAssessmentForAction(assessment);
        setActionType('unpublish');
        setModalType('confirm');
        break;
      default:
        break;
    }
  };

  const handleDeleteConfirm = async () => {
    try {
      const result = await adminServices.deleteAssessment(selectedAssessment.id);
      if (result && result.status === 200) {
        setSnackbarTitle('Assessment deleted successfully');
        setOpenSnackbar(true);
        setDeleteModalOpen(false);
        getAssessments();
      }
    } catch (error) {
      console.error('Error deleting assessment:', error);
      setSnackbarTitle('Error deleting assessment');
      setOpenSnackbar(true);
    }
  };

  const handlePreview = async (assessment) => {
    setPreviewOpen(true);
    setPreviewLoading(true);
    setPreviewAssessment(assessment);
    setOpenActionMenuId(null);

    try {
      const result = await adminServices.getAssessmentById(assessment.id);
      const assessmentData = result?.data?.data || result?.data || assessment;
      setPreviewAssessment(assessmentData);
    } catch (error) {
      console.error('Error fetching assessment preview:', error);
      setSnackbarTitle('Failed to load full assessment details');
      setOpenSnackbar(true);
    } finally {
      setPreviewLoading(false);
    }
  };
  const stripHtml = (html) => html?.replace(/<[^>]+>/g, '') || '';

  const columns = [
    // {
    //   label: 'Title',
    //   key: 'title',
    //   render: (row) => (
    //     <div className="flex flex-col">
    //       <span className="text-sm font-semibold text-gray-900">
    //         {row.title || '-'}
    //       </span>
    //       {row.description && (
    //         <span
    //           className="text-xs text-gray-600 mt-0.5"
    //           dangerouslySetInnerHTML={{ __html: row.description }}
    //         />
    //       )}
    //       <span className="text-xs text-gray-500 mt-0.5">
    //         {row.email || '-'} • {row.modified_date_time ? moment(row.modified_date_time).format("DD/MM/YYYY") : '-'}
    //       </span>
    //     </div>
    //   ),
    // },
    {
      label: 'Title',
      key: 'title',
      render: (row) => {
        const descText = stripHtml(row.description);
        const shortDesc =
          descText.length > 68 ? descText.slice(0, 68) + '...' : descText;

        return (
          <div className="flex flex-col">

            <span className="text-xs text-gray-500 mt-0.5">
              <span className="font-medium text-gray-600">Internal Name:</span>{" "}
              {row?.internaltitle ? row.internaltitle : "-"}
            </span>
            <span className="text-xs text-gray-500 mt-0.5">
              <span className="font-medium text-gray-600">Display Name:</span>{" "}
              {row.title || '-'}
            </span>
            <span className="text-xs text-gray-500 mt-0.5">
              <span className="font-medium text-gray-600">Description:</span>{" "}
              {row.description && (
                <span
                  className="text-xs text-gray-600 mt-0.5 cursor-pointer"
                  title={descText}
                >
                  {shortDesc}
                </span>
              )}
            </span>

            <span className="text-xs text-gray-500 mt-0.5">
              <span className="font-medium text-gray-600">Created by:</span>{" "}
              {row.email || "-"} •{" "}
              {row.created_date_time
                ? moment(row.created_date_time).format("DD/MM/YYYY")
                : "-"}
            </span>

            <span className="text-xs text-gray-500 mt-0.5">
              <span className="font-medium text-gray-600">Updated by:</span>{" "}
              {row?.updatedemail ?
                <>
                  {row?.updatedemail || "-"} •{" "}
                  {row?.modified_date_time
                    ? moment(row.modified_date_time).format("DD/MM/YYYY")
                    : "-"}
                </>
                : '-'}
            </span>

            <span className="text-xs text-gray-500 mt-0.5">
              <span className="font-medium text-gray-600">Batch Name:</span>{" "}
              {row?.batch_names ?
                <>

                  {row?.batch_names?.length
                    ? `${row.batch_names.join(', ')}.`
                    : '-'}
                </>
                : '-'}
            </span>
          </div>
        );
      },
    },
    {
      label: 'Type',
      key: 'assessment_pattern_name',
      render: (row) => (
        <div className="flex items-center gap-2">
          <FileText size={16} className="text-blue-600" />
          <span className="text-sm text-blue-600 font-medium">
            {row.assessment_pattern_name || '-'}
          </span>
        </div>
      ),
    },
    {
      label: 'Category',
      key: 'type',
      render: (row) => (
        <span className="text-sm text-gray-700">
          {row.type || '-'}
        </span>
      ),
    },
    {
      label: 'Assessment Length',
      key: 'assessment_length',
      render: (row) => (
        <span className="text-sm text-gray-700">
          {row.assessment_length || '-'}
        </span>
      ),
    },
    {
      label: 'Status',
      key: 'status_type',
      render: (row) => {
        return (
          <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${getDifficultyColor(row.status)}`}>
            {row.status === 'ON_MAINTENANCE' ? 'MAINTENANCE' : row.status}
          </span>
        );
      },
    },
    {
      label: "Actions",
      key: "actions",
      render: (row) => (
        <div className="relative flex items-center justify-end">
          <button
            ref={(el) => (menuRefs.current[`btn_${row.id}`] = el)}
            id={`assessments-row-actions-btn-${row.id}`}
            type="button"
            onClick={() => {
              if (openActionMenuId === row.id) {
                setOpenActionMenuId(null);
                return;
              }
              const btn = menuRefs.current[`btn_${row.id}`];
              if (btn) {
                const rect = btn.getBoundingClientRect();
                setMenuPosition({
                  top: rect.bottom + window.scrollY,
                  right: window.innerWidth - rect.right,
                });
              }
              setOpenActionMenuId(row.id);
            }}
            className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors duration-150"
            title="Actions"
          >
            <MoreVertical className="w-5 h-5" />
          </button>
        </div>
      ),
    },
    // {
    //   label: 'Actions',
    //   key: 'actions',
    //   render: (row) => (
    //     <div className="relative flex items-center justify-end">
    //       <button
    //         type="button"
    //         onClick={(e) => {
    //           const rect = e.currentTarget.getBoundingClientRect();
    //           const spaceBelow = window.innerHeight - rect.bottom;
    //           setMenuOpenUp(spaceBelow < 180);
    //           setOpenActionMenuId((prev) => (prev === row.id ? null : row.id));
    //         }}
    //         className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors duration-150"
    //         title="Actions"
    //       >
    //         <MoreVertical className="w-5 h-5" />
    //       </button>

    //       {openActionMenuId === row.id && (
    //        <div className={`absolute right-0 z-[9999] w-44 rounded-lg border border-gray-200 bg-white shadow-lg py-1 ${menuOpenUp ? 'bottom-10' : 'top-10'}`}> 
    //           <button
    //             type="button"
    //             onClick={() => handlePreview(row)}
    //             className="w-full px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
    //           >
    //             <Eye className="w-4 h-4" />
    //             Preview
    //           </button>
    //           <button
    //             type="button"
    //             onClick={() => {
    //               handleActionClick('publishChanges', row);
    //               setOpenActionMenuId(null);
    //             }}
    //             className="w-full px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
    //           >
    //             <Upload className="w-4 h-4" />
    //             Ready to Publish
    //           </button>
    //           <button
    //             type="button"
    //             onClick={() => {
    //               // handleActionClick('continueEditing', row);
    //               handleActionClick('continueEditing', row);
    //               setOpenActionMenuId(null);
    //             }}
    //             className="w-full px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
    //           >
    //             <RefreshCw className="w-4 h-4" />
    //             Continue Editing
    //           </button>

    //          {row?.status!=='ACTIVE' &&<button
    //             type="button"
    //             onClick={() => {
    //               handleActionClick('delete', row);
    //               setOpenActionMenuId(null);
    //             }}
    //             className="w-full px-3 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
    //           >
    //             <Trash2 className="w-4 h-4" />
    //             Delete
    //           </button>}
    //         </div>
    //       )}
    //     </div>
    //   ),
    // },
  ];

  const totalPages = Math.max(1, Math.ceil(maxCount / size));

  const renderEmptyState = () => (
    <div id="assessments-empty-state" className="flex flex-col items-center justify-center py-12">
      <ClipboardList className="w-16 h-16 text-gray-400 mb-4" />
      <h3 className="text-lg font-medium text-gray-900 mb-2">
        No assessments found
      </h3>
      <p className="text-sm text-gray-500 mb-6">
        Get started by creating your first assessment
      </p>
      <div className="flex gap-3">
        <button
          id="assessments-empty-create-linear-btn"
          onClick={handleCreateLinear}
          className="inline-flex items-center justify-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors duration-150"
        >
          <FileText className="w-5 h-5 mr-2" />
          Create Linear
        </button>
        <button
          id="assessments-empty-create-adaptive-btn"
          onClick={handleCreateAdaptive}
          className="inline-flex items-center justify-center px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white font-medium rounded-lg transition-colors duration-150"
        >
          <Zap className="w-5 h-5 mr-2" />
          Create Adaptive
        </button>
      </div>

    </div>
  );
  const formatDateTime = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = '00';
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours %= 12;
    hours = hours || 12;
    const formattedHours = hours.toString().padStart(2, '0');

    return `${day}/${month}/${year} ${formattedHours}:${minutes}:${seconds} ${ampm}`;
  };

  const handlePublishSubmit = async () => {
    try {
      if (!publishFromDate || !publishToDate) {
        setSnackbarTitle('From Date and To Date are required');
        setOpenSnackbar(true);
        return;
      }

      setActionLoading(true);

      const userData = {
        message: publishMessage,
        fromDate: formatDateTime(publishFromDate),
        toDate: formatDateTime(publishToDate),
        from: 'assessment'
      };

      const result = await adminServices.UpdateGeneralAssessmentStatus(
        selectedAssessmentForAction.id,
        'ON_MAINTENANCE',
        userData
      );

      if (result && (result.status === 200 || result.ok)) {
        setSnackbarTitle('Assessment moved to maintenance mode successfully');
        setOpenSnackbar(true);
        setModalType(null);

        const assessment = selectedAssessmentForAction;
        if (assessment?.assessment_pattern_name === 'Linear') {
          navigate('/app/assessmentCreate?type=linear', {
            state: { assessmentId: assessment.id },
          });
        } else {
          navigate('/app/assessmentCreate?type=adaptive', {
            state: { assessmentId: assessment.id },
          });
        }
        getAssessments();

        setPublishMessage('');
        setPublishFromDate('');
        setPublishToDate('');
        setSelectedAssessmentForAction(null);
      }
    } catch (error) {
      console.error('Error updating maintenance status:', error);
      setSnackbarTitle('Failed to move assessment to maintenance');
      setOpenSnackbar(true);
    } finally {
      setActionLoading(false);
    }
  };

  return (
    <Page title="Assessments">
      <div id="assessments-page" className="px-4 sm:px-6 lg:px-8 py-8">
        <div id="assessments-header" className="mb-6">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h2 id="assessments-title" className="text-2xl font-bold text-gray-900">Assessments</h2>
              <p id="assessments-subtitle" className="mt-1 text-sm text-gray-500">Create and manage LINEAR and ADAPTIVE assessments</p>
            </div>
            <div id="assessments-create-buttons" className="flex gap-3">
              <button
                id="assessments-create-linear-btn"
                onClick={handleCreateLinear}
                className="inline-flex items-center justify-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors duration-150 shadow-sm"
              >
                <FileText className="w-5 h-5 mr-2" />
                Linear
              </button>
              <button
                id="assessments-create-adaptive-btn"
                onClick={handleCreateAdaptive}
                className="inline-flex items-center justify-center px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white font-medium rounded-lg transition-colors duration-150 shadow-sm"
              >
                <Zap className="w-5 h-5 mr-2" />
                Adaptive
              </button>

              <button
                id="assessments-arrange-order-btn"
                onClick={() => setOrderModalOpen(true)}
                className="inline-flex items-center justify-center px-4 py-2 border border-gray-300 bg-white hover:bg-gray-50 text-gray-700 font-medium rounded-lg transition-colors duration-150 shadow-sm"
              >
                <GripVertical className="w-5 h-5 mr-2" />
                Arrange Order
              </button>
            </div>
          </div>
        </div>

        <div id="assessments-filters-card" className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
          <div className="flex items-center justify-between mb-4">
            <h3 id="assessments-filters-title" className="text-sm font-semibold text-gray-700">Filters</h3>
            <button
              id="assessments-clear-filters-btn"
              onClick={handleClearFilters}
              className="text-sm text-blue-600 hover:text-blue-700 font-medium"
            >
              Clear All
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3">
            <div>
              <label htmlFor="search-input" className="block text-sm font-medium text-gray-700 mb-1">
                Search
              </label>
              <div className="relative">
                <input
                  id="search-input"
                  type="text"
                  placeholder="Search assessments..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                />
                <Search className="absolute left-3 top-2.5 w-5 h-5 text-gray-400" />
              </div>
            </div>
            <div>
              <label htmlFor="type-select" className="block text-sm font-medium text-gray-700 mb-1">
                Category
              </label>
              <select
                id="type-select"
                value={category || ''}
                onChange={(e) => setCategory(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
              >
                <option value="">All Category</option>
                {assessmentTypeList && assessmentTypeList?.length > 0 && assessmentTypeList.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.code}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label htmlFor="type-select" className="block text-sm font-medium text-gray-700 mb-1">
                Assessment Type
              </label>
              <select
                id="type-select"
                value={typeFilter}
                onChange={(e) => setTypeFilter(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
              >
                <option value="">All Types</option>
                <option value="Linear">Linear</option>
                <option value="Adaptive">Adaptive</option>
              </select>
            </div>
            <div>
              <label htmlFor="type-select" className="block text-sm font-medium text-gray-700 mb-1">
                Assessment Length
              </label>
              <select
                id="type-length"
                value={length}
                onChange={(e) => setLength(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
              >
                <option value="">All</option>
                <option value="Chapter Test">Chapter Test</option>
                <option value="Full Test">Full Test</option>
                <option value="Subject Test">Subject Test</option>
              </select>
            </div>
            <div>
              <label htmlFor="status-select" className="block text-sm font-medium text-gray-700 mb-1">
                Status
              </label>
              <select
                id="status-select"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
              >
                <option value="">All Status</option>
                <option value="INACTIVE">InActive</option>
                <option value="ACTIVE">Active</option>
                <option value="ON_MAINTENANCE">Maintenance</option>
              </select>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div id="assessments-table-card" className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-visible">
          <ResponsiveTable
            columns={columns}
            data={assessments}
            loading={loading}
            onActionClick={handleActionClick}
            emptyStateComponent={renderEmptyState}
          />
          <div id="assessments-pagination-bar" className="px-4 py-3 border-t border-gray-200 sm:px-6">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              {/* Results info */}
              <div id="assessments-pagination-info" className="text-sm text-gray-700">
                Showing{' '}
                <span className="font-medium">
                  {maxCount === 0 ? 0 : (page - 1) * size + 1}
                </span>{' '}
                to{' '}
                <span className="font-medium">
                  {Math.min(page * size, maxCount)}
                </span>{' '}
                of <span className="font-medium">{maxCount}</span> results
              </div>
              <div id="assessments-pagination-controls" className="flex items-center gap-2">

                <select
                  id="assessments-page-size-select"
                  value={size}
                  onChange={(e) => {
                    setSize(Number(e.target.value));
                  }}
                  className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                <button
                  id="assessments-pagination-prev-btn"
                  onClick={() => setPage(page - 1)}
                  disabled={page === 1}
                  className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-150"
                >
                  Previous
                </button>

                <div id="assessments-pagination-pages" className="hidden sm:flex items-center gap-1">
                  {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                    let pageNum;
                    if (totalPages <= 5) {
                      pageNum = i + 1;
                    } else if (page <= 3) {
                      pageNum = i + 1;
                    } else if (page >= totalPages - 2) {
                      pageNum = totalPages - 4 + i;
                    } else {
                      pageNum = page - 2 + i;
                    }

                    return (
                      <button id={`assessments-page-btn-${pageNum}`} key={i} onClick={() => setPage(pageNum)} className={`px-3 py-1.5 border rounded-lg text-sm font-medium transition-colors duration-150 ${page === pageNum ? 'bg-blue-600 text-white border-blue-600' : 'border-gray-300 text-gray-700 hover:bg-gray-50'}`}>
                        {pageNum}
                      </button>
                    );
                  })}
                </div>

                <button
                  id="assessments-pagination-next-btn"
                  onClick={() => setPage(page + 1)}
                  disabled={page === totalPages}
                  className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-150"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SnackBar
        open={openSnackbar}
        snackbarTitle={snackbarTitle}
        close={() => setOpenSnackbar(false)}
      />
      {deleteModalOpen && (
        <DeleteAlert
          open={deleteModalOpen}
          close={() => setDeleteModalOpen(false)}
          confirm={handleDeleteConfirm}
          title="Delete Assessment"
          message="Are you sure you want to delete this assessment? This action cannot be undone."
        />
      )}
      {modalType === 'date' && (
        <div id="assessments-date-modal-overlay" className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div id="assessments-date-modal" className="bg-white rounded-lg shadow-lg p-6 w-[500px]">

            <h3 id="assessments-date-modal-title" className="text-lg font-semibold mb-4">
              Provide Message and Date Range
            </h3>

            <textarea
              id="assessments-date-modal-message"
              placeholder="Message"
              value={publishMessage}
              onChange={(e) => setPublishMessage(e.target.value)}
              className="w-full border rounded-md p-2 mb-4"
            />

            <input
              id="assessments-date-modal-from-date"
              type="datetime-local"
              value={publishFromDate}
              onChange={(e) => setPublishFromDate(e.target.value)}
              className="w-full border rounded-md p-2 mb-4"
            />

            <input
              id="assessments-date-modal-to-date"
              type="datetime-local"
              value={publishToDate}
              onChange={(e) => setPublishToDate(e.target.value)}
              className="w-full border rounded-md p-2 mb-6"
            />

            <div className="flex justify-end gap-3">
              <button
                id="assessments-date-modal-cancel-btn"
                disabled={actionLoading}
                onClick={() => setModalType(null)}
                className={`px-4 py-2 border border-gray-300 rounded-lg text-sm ${actionLoading ? 'opacity-50 cursor-not-allowed' : ''
                  }`}
              >
                Cancel
              </button>

              <button
                id="assessments-date-modal-submit-btn"
                disabled={actionLoading}
                onClick={handlePublishSubmit}
                className={`px-4 py-2 bg-orange-600 text-white rounded-md ${actionLoading ? 'opacity-50 cursor-not-allowed' : ''
                  }`}
              >
                {actionLoading ? 'Processing...' : 'Submit'}
              </button>
            </div>
          </div>
        </div>
      )}

      {modalType === 'confirm' && (
        <div id="assessments-confirm-modal-overlay" className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div id="assessments-confirm-modal" className="bg-white rounded-2xl shadow-2xl p-8 w-[650px]">
            {actionType === 'edit' && (
              <>
                <h3 id="assessments-confirm-edit-title" className="text-2xl font-semibold text-gray-900 mb-6">
                  Take Assessment Offline for Editing?
                </h3>

                <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                  This will put "
                  <span className="font-semibold text-gray-900">
                    {selectedAssessmentForAction?.title}
                  </span>
                  " into maintenance mode.
                  The assessment will be temporarily unavailable to end-users while you make changes.
                </p>

                <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                  A snapshot of the current published version will be saved,
                  allowing you to revert if needed.
                </p>

                <p className="text-sm text-gray-600 mb-8 leading-relaxed">
                  <span className="font-semibold text-gray-900">Alternative:</span>{' '}
                  You can use "Duplicate" to create a copy and leave the
                  original published version untouched.
                </p>

                <div className="flex justify-end gap-4">
                  <button
                    id="assessments-confirm-edit-cancel-btn"
                    onClick={() => setModalType(null)}
                    className="px-5 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 hover:bg-gray-50 transition"
                  >
                    Cancel
                  </button>

                  <button
                    id="assessments-confirm-edit-proceed-btn"
                    onClick={() =>
                      selectedAssessmentForAction.status === 'ACTIVE'
                        ? setModalType('date')
                        : NavigateEdit(selectedAssessmentForAction)
                    } className="px-6 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded-lg text-sm font-medium transition" >
                    Take Offline & Edit
                  </button>
                </div>
              </>
            )}

            {(actionType === 'publish' || actionType === "unpublish") && (
              <>

                <div className="mb-6">

                  <div className="flex items-center gap-2 mb-4">
                    <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${actionType === 'publish' ? 'border-green-500' : 'border-red-500'}`}>
                      <svg
                        className={`w-3 h-3 ${actionType === 'publish' ? 'text-green-500' : 'text-red-500'}`}
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>

                    <h3 className="text-lg font-semibold text-gray-900">
                      {actionType === 'publish' ? "Ready to Publish" : "Ready to UnPublish"}
                    </h3>
                  </div>

                  <p className="text-sm text-gray-600 mb-4">
                    This assessment is ready to be  {actionType === 'publish' ? "published" : "Unpublish"}. Are you sure you want to proceed?
                  </p>

                  <div
                    className={`flex items-center gap-2 rounded-md px-4 py-3 ${actionType === 'publish'
                      ? 'bg-green-50 border border-green-200'
                      : 'bg-red-50 border border-red-200'
                      }`}
                  >
                    <svg
                      className="w-4 h-4 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="3"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                    <span className={`text-sm font-medium ${actionType === 'publish' ? 'text-green-700' : 'text-red-400'
                      }`}
                    >
                      {actionType === 'publish'
                        ? 'All validation checks passed. This assessment is ready to be published'
                        : 'All validation checks passed. This assessment is ready to be unpublished'}
                    </span>
                    {/* <span className="text-sm text-green-700 font-medium">
                      {actionType === 'publish' ? "All validation checks passed. This assessment is ready to be published" : "All validation checks passed. This assessment is ready to be Unpublished"}
                    </span> */}
                  </div>

                </div>

                <div className="flex justify-end gap-3">
                  <button
                    id="assessments-confirm-publish-cancel-btn"
                    onClick={() => setModalType(null)}
                    className="px-4 py-2 border border-gray-300 rounded-lg text-sm"
                  >
                    No, wait
                  </button>

                  <button
                    id="assessments-confirm-publish-proceed-btn"
                    disabled={actionLoading}
                    // className={`px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg text-sm font-medium transition ${actionLoading ? 'opacity-50 cursor-not-allowed' : ''
                    //   }`}
                    className={`px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg text-sm font-medium transition ${actionLoading ? 'opacity-50 cursor-not-allowed' : ''
                      }`}
                    onClick={async () => {
                      try {
                        setActionLoading(true);

                        const result = await adminServices.UpdateGeneralAssessmentStatus(
                          selectedAssessmentForAction.id,
                          actionType === 'publish' ? 'ACTIVE' : 'INACTIVE',
                          {
                            message: '',
                            fromDate: '',
                            toDate: '',
                            from: 'assessment'
                          }
                        );

                        if (result && result.status === 200) {
                          setSnackbarTitle(actionType === 'publish' ? 'Assessment published successfully' : 'Assessment unpublished successfully');
                          setOpenSnackbar(true);
                          setModalType(null);
                          setSelectedAssessmentForAction(null);

                          getAssessments();
                        }
                      } catch (error) {
                        console.error('Publish error:', error);
                        setSnackbarTitle('Error publishing assessment');
                        setOpenSnackbar(true);
                        setModalType(null);
                      } finally {
                        setActionLoading(false);
                      }
                    }}
                  >
                    {actionLoading ? 'Publishing...' : (actionType === 'publish' ? 'Yes, publish' : 'Yes, unpublish')} </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      <ViewAssessmentModal
        open={previewOpen}
        onClose={(event, reason) => {
          if (reason === "backdropClick") return;
          setPreviewOpen(false);
          setPreviewAssessment(null);
          setPreviewLoading(false);
        }}
        assessment={previewAssessment}
        loading={previewLoading}
      />
      {openActionMenuId && (() => {
        const row = assessments.find(a => a.id === openActionMenuId);
        console.log(row, "rowrowrowrow");

        if (!row) return null;
        return ReactDOM.createPortal(
          <div
            id={`assessments-action-menu-${openActionMenuId}`}
            ref={(el) => (menuRefs.current[openActionMenuId] = el)}
            style={{
              position: 'absolute',
              top: menuPosition.top,
              right: menuPosition.right,
              zIndex: 9999,
            }}
            className="w-44 rounded-lg border border-gray-200 bg-white shadow-lg py-1"
          >
            <button
              id={`assessments-menu-preview-btn-${openActionMenuId}`}
              type="button"
              onClick={() => { handlePreview(row); setOpenActionMenuId(null); }}
              className="w-full px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
            >
              <Eye className="w-4 h-4" />
              Preview
            </button>
            {(row.status === "INACTIVE" || row.status === "ON_MAINTENANCE") &&
              <button
                id={`assessments-menu-publish-btn-${openActionMenuId}`}
                type="button"
                onClick={() => { handleActionClick("publishChanges", row); setOpenActionMenuId(null); }}
                className="w-full px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
              >
                <Upload className="w-4 h-4" />
                Ready to Publish
              </button>}
            {(row.status === "ACTIVE" || row.status === "ON_MAINTENANCE") &&
              <button
                id={`assessments-menu-unpublish-btn-${openActionMenuId}`}
                type="button"
                onClick={() => { handleActionClick("unpublishChanges", row); setOpenActionMenuId(null); }}
                className="w-full px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
              >
                <Upload className="w-4 h-4" />
                Back to Draft
              </button>}
            <button
              id={`assessments-menu-edit-btn-${openActionMenuId}`}
              type="button"
              onClick={() => { handleActionClick("continueEditing", row); setOpenActionMenuId(null); }}
              className="w-full px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
            >
              <RefreshCw className="w-4 h-4" />
              Continue Editing
            </button>
            {row?.status !== "ACTIVE" && (
              <button
                id={`assessments-menu-delete-btn-${openActionMenuId}`}
                type="button"
                onClick={() => { handleActionClick("delete", row); setOpenActionMenuId(null); }}
                className="w-full px-3 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
              >
                <Trash2 className="w-4 h-4" />
                Delete
              </button>
            )}
          </div>,
          document.body
        );
      })()}

      <AssessmentOrderModal
        open={orderModalOpen}
        onClose={() => setOrderModalOpen(false)}
        categoryList={assessmentTypeList}
        onSaved={(msg) => {
          setSnackbarTitle(msg);
          setOpenSnackbar(true);
          getAssessments();
        }}
      />
    </Page>
  );
};

export default Assessments;
